var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ButtonAFY, ContextMenuAFY, IconAFY, icons, sizes, sizesIcon, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../../assets/themes/theme";
import { DivLongText, DivStatus, } from "../../../apap/salesCore/auditPage/assets/style";
import React from "react";
export var planDto = {
    titlePage: "Plan",
    viewType: "2",
    titleMetaTag: "Affinity Plan",
    informationPage: {
        backgroundColor: themeCore.colors.background,
        colorText: themeCore.colors.secondaryText,
        description: "Seleccion el plan que necesite el cliente",
        icon: icons.Help,
        iconSize: sizesIcon.standard,
        iconColor: themeCore.colors.primary,
    },
    filter: {
        backgroundColor: "#FFFFFF",
        bgChipInsurers: "#fff",
        bgChipInsurersSelected: "#EBEEF6",
        bgColorButton: "#fff",
        bgColorComparativeButton: "#3A56A1",
        bgColorIconButton: "#EBEEF6",
        bgColorIconButtonSelected: "#3A56A1",
        colorIconButton: "#3A56A1",
        colorIconButtonSelected: "#fff",
        colorIconChip: "#3A56A1",
        colorText: "#3A56A1",
        comparativeTextButton: "ver comparativa",
        comparativeTextColor: "#fff",
        insurers: [],
        title: "Patrocinador",
        titleFirstChip: "Todas",
    },
    data: [],
};
export var TabAutoColumns = function (f, isQuote) {
    var active = isQuote == "false";
    var columns = [
        {
            field: "type",
            headerName: "Acciones",
            width: 150,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, disableRipple: true, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: active,
                            icon: {
                                color: "#006ac6",
                                icon: icons.Edit,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Actualizar",
                        },
                    ], onClickContextMenu: f, sizeIcon: sizesIcon.smallXl }) }))); },
        },
        {
            field: "brand",
            headerName: "Marca",
            width: 150,
        },
        {
            field: "model",
            headerName: "Modelo",
            width: 150,
        },
        {
            field: "color",
            headerName: "Color",
            width: 150,
        },
        {
            field: "price",
            headerName: "Valor",
            width: 150,
        },
        {
            field: "cylinders",
            headerName: "Numero de cilindros",
            width: 250,
        },
        {
            field: "fueltype",
            headerName: "Tipo de combustible",
            width: 250,
        },
        {
            field: "plate",
            headerName: "Placa",
            width: 150,
        },
    ];
    return columns;
};
export var Tab1Columns = function (showEdit, showDelete, canEditInsurance, rows) {
    // Verificar si algún registro tiene datos en marriedName
    var hasMarriedName = rows === null || rows === void 0 ? void 0 : rows.some(function (row) { return row.marriedName && row.marriedName.trim() !== ""; });
    var columns = [
        {
            field: "type",
            headerName: "Tipo asegurado",
            width: 180,
        },
        {
            field: "names",
            headerName: "Nombres",
            width: 280,
        },
        {
            field: "lastNames",
            headerName: "Apellidos",
            width: 280,
        },
        {
            field: "phone1",
            headerName: "Teléfono",
            width: 150,
        },
        {
            field: "dob",
            headerName: "Fecha nacimiento",
            width: 220,
        },
    ];
    if (hasMarriedName) {
        columns.splice(3, 0, {
            field: "marriedName",
            headerName: "Apellido de casada",
            width: 240,
        });
    }
    if (canEditInsurance) {
        columns.unshift({
            field: "actions",
            headerName: "Acciones",
            width: 160,
            renderCell: function (params) { return (_jsx(_Fragment, { children: params.row.type !== "Titular" && (_jsxs("div", __assign({ style: { display: "flex", gap: "8px" } }, { children: [_jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Editar", color: themeCore.colors.buttonPrimary, onClick: function () { return showEdit(params); } }), _jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Eliminar", color: themeCore.colors.error, onClick: function () { return showDelete(params); } })] }))) })); },
        });
    }
    return columns;
};
export var Tab2Columns = function (showEdit, canEditBeneficiary) {
    var columns = [
        {
            field: "type",
            headerName: "Tipo beneficiario",
            width: 200,
        },
        {
            field: "names",
            headerName: "Nombres",
            width: 280,
        },
        {
            field: "lastNames",
            headerName: "Apellidos",
            width: 280,
        },
        {
            field: "dob",
            headerName: "Fecha nacimiento",
            width: 230,
        },
        {
            field: "percentage",
            headerName: "Porcentaje",
            width: 170,
        },
    ];
    if (canEditBeneficiary) {
        columns.unshift({
            field: "actions",
            headerName: "Acciones",
            width: 100,
            renderCell: function (params) { return (_jsx(_Fragment, { children: params.row.type !== "Titular" && (_jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Editar", color: themeCore.colors.buttonPrimary, onClick: function () { return showEdit(params); } })) })); },
        });
    }
    return columns;
};
export var TabCardInfoColumns = [
    {
        field: "accountNumber",
        headerName: "Número de tarjeta ",
        width: 250,
    },
    {
        field: "revolvingLimit",
        headerName: "Límite Revolvente",
        width: 250,
    },
];
export var Tab3Columns = [
    {
        field: "accountName",
        headerName: "Nombre",
        width: 300,
    },
    {
        field: "accountType",
        headerName: "Tipo ",
        width: 250,
    },
    {
        field: "accountNumber",
        headerName: "Número",
        width: 200,
    },
    {
        field: "paymentMode",
        headerName: "Modo de pago",
        width: 150,
    },
    {
        field: "prime",
        headerName: "Prima",
        width: 150,
    },
];
export var dataEditVehicleForm = {
    carDetails: [
        {
            brand: {
                id: "",
                name: "",
            },
            model: {
                id: "",
                name: "",
            },
            version: {
                id: "",
                name: "",
            },
        },
    ],
    year: "",
    carColor: [
        {
            id: "",
            name: "",
        },
    ],
    chassisNumber: "",
    price: "",
    numberCylinders: [
        {
            id: "",
            name: "",
        },
    ],
    fuelType: [
        {
            id: "",
            name: "",
        },
    ],
    registrationNumber: "",
    carCondition: [
        {
            id: "",
            name: "",
        },
    ],
};
export var StatementColumns = function (tl) {
    var columns = [
        {
            field: "reference",
            headerName: "Referencia de cobro",
            width: 175,
        },
        {
            field: "amount",
            headerName: "Monto a pagar",
            width: 175,
        },
        {
            field: "paymentDate",
            headerName: "Mes cobrado",
            width: 175,
        },
        {
            field: "state",
            headerName: "Estado",
            width: 175,
        },
        {
            field: "datePaid",
            headerName: "Fecha de pago",
            width: 175,
        },
        {
            field: "dateExpire",
            headerName: "Fecha de vencimiento",
            width: 175,
        },
    ];
    return columns;
};
var getStatusColor = function (state) {
    switch (state) {
        case "Listo":
            return "green";
        case "Rechazado":
            return "red";
        case "Pendiente":
            return "yellow";
        case "Sin documento":
            return "blue";
        default:
            return "gray";
    }
};
export var AdditionalDocumentationColumns = function (handleClickContextMenu) {
    var columns = [
        {
            field: "actions",
            headerName: "Acciones",
            width: 150,
            renderCell: function (param) {
                return (_jsx("div", __assign({ style: { display: "flex" } }, { children: _jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                            {
                                disabled: false,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.UploadFile,
                                    size: sizesIcon.standard,
                                },
                                id: "1",
                                name: "Subir documento",
                            },
                            {
                                disabled: !param.row.documentClientUrl,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Visibility,
                                    size: sizesIcon.standard,
                                },
                                id: "2",
                                name: "Visualizar",
                            },
                        ], onClickContextMenu: function (item) { return handleClickContextMenu(item, param); }, sizeIcon: sizesIcon.standard }) })));
            },
        },
        {
            field: "docType",
            width: 450,
            headerName: "Tipo de documento",
            renderCell: function (params) {
                return _jsx(DivLongText, { children: params.value });
            },
        },
        {
            width: 200,
            field: "state",
            headerName: "Estado",
            renderCell: function (params) {
                return (_jsxs(DivStatus, { children: [_jsx(IconAFY, { icon: icons.Circle, color: getStatusColor(params.value) }), " ", params.value] }));
            },
        },
        {
            field: "mandatory",
            headerName: "Carácter",
            width: 125,
        },
        {
            field: "date",
            headerName: "Fecha",
            width: 200,
        },
        {
            field: "user",
            headerName: "Usuario",
            width: 175,
        },
    ];
    return columns;
};
export var rowsClientDocument = [
    {
        id: "",
        docType: "",
        state: "",
        date: "",
        user: "",
    },
];
export var Tab4Columns = [
    {
        editable: true,
        field: "name",
        flex: 1,
        headerName: "Nombre",
        width: 150,
    },
    {
        editable: true,
        field: "lastName",
        flex: 1,
        headerName: "Apellidos",
        width: 150,
    },
    {
        editable: true,
        field: "documentNumber",
        flex: 1,
        headerName: "No. Documento",
        width: 150,
    },
    {
        editable: true,
        field: "birthday",
        flex: 1,
        headerName: "Fecha Nacimiento",
        width: 200,
        renderCell: function (params) {
            if (!params.value)
                return _jsx("span", { children: "-" });
            var date = new Date(params.value);
            if (isNaN(date.getTime()))
                return _jsx("span", { children: params.value });
            var day = String(date.getDate()).padStart(2, "0");
            var month = String(date.getMonth() + 1).padStart(2, "0");
            var year = date.getFullYear();
            return _jsx("span", { children: "".concat(day, "/").concat(month, "/").concat(year) });
        },
    },
    {
        editable: false,
        field: "edad",
        flex: 1,
        headerName: "Edad",
        width: 80,
        renderCell: function (params) {
            return _jsx("span", { children: params.value || "-" });
        },
    },
    {
        editable: true,
        field: "passport",
        flex: 1,
        headerName: "Pasaporte",
        width: 150,
    },
    {
        editable: true,
        field: "phoneNumber",
        flex: 1,
        headerName: "Teléfono",
        width: 150,
    },
    {
        editable: true,
        field: "email",
        flex: 1,
        headerName: "Correo Electronico",
        width: 200,
    },
];
export var TabRealEstateColumns = function (handleClickContextMenu) {
    var columns = [
        {
            field: "actions",
            headerName: "Acciones",
            width: 75,
            renderCell: function (param) {
                return (_jsx("div", __assign({ style: { display: "flex" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                            {
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Visibility,
                                    size: sizesIcon.standard,
                                },
                                id: "2",
                                name: "Visualizar",
                            },
                        ], onClickContextMenu: function (item) { return handleClickContextMenu(item, param); }, sizeIcon: sizesIcon.standard }) })));
            },
        },
        {
            field: "ownerName",
            flex: 1,
            headerName: "Razón Social",
            width: 150,
        },
        {
            field: "propertyTypeId",
            flex: 1,
            headerName: "Tipo de sector de negocio",
            width: 150,
        },
        {
            field: "businessShift",
            flex: 1,
            headerName: "Giro o actividad del negocio",
            width: 150,
        },
        {
            field: "typeConstruction",
            flex: 1,
            headerName: "Tipo de construcción",
            width: 150,
        },
    ];
    return columns;
};
export var TabRealEstateHomeColumns = [
    {
        field: "typeConstructionName",
        headerName: "Tipo de construcción",
        width: 150,
    },
    {
        field: "propertyAddress",
        flex: 1,
        headerName: "Dirección de la propiedad",
    },
];
export var TabAppointmentColumns = function (showEdit, canEdit, rows) {
    var columns = [
        {
            field: "appointmentDate",
            flex: 1,
            headerName: "Fecha Cita",
            width: 150,
        },
        {
            field: "status",
            flex: 1,
            headerName: "Estado",
            width: 150,
        },
        {
            field: "comment",
            flex: 1,
            headerName: "Comentarios",
            width: 150,
        },
        {
            field: "officer",
            flex: 1,
            headerName: "Asesor",
            width: 150,
        },
    ];
    if (canEdit) {
        columns.unshift({
            field: "actions",
            headerName: "Acciones",
            width: 100,
            renderCell: function (params) { return (_jsx(_Fragment, { children: params.row.type !== "Titular" && (_jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Editar", color: themeCore.colors.buttonPrimary, onClick: function () { return showEdit(params); } })) })); },
        });
    }
    return columns;
};
export var TabAppointmentManagerColumns = function (showEdit, canEdit, rows) {
    var columns = [
        {
            field: "date",
            flex: 1,
            headerName: "Fecha Gestión",
            width: 150,
        },
        {
            field: "action",
            flex: 1,
            headerName: "Tipo de Gestión",
            width: 150,
        },
        {
            field: "status",
            flex: 1,
            headerName: "Estado Cita/Motivo",
            width: 150,
        },
        {
            field: "comment",
            flex: 1,
            headerName: "Comentarios",
            width: 150,
        },
        {
            field: "newAppointmentDate",
            flex: 1,
            headerName: "Fecha Nueva Cita",
            width: 150,
        },
        {
            field: "approvedPremium",
            flex: 1,
            headerName: "Prima Aprobada",
            width: 150,
        },
    ];
    if (canEdit) {
        columns.unshift({
            field: "actions",
            headerName: "Acciones",
            width: 100,
            renderCell: function (params) { return (_jsx(_Fragment, { children: params.row.type !== "Titular" && (_jsx(ButtonAFY, { size: sizes.small, variant: variants.text, label: "Editar", color: themeCore.colors.buttonPrimary, onClick: function () { return showEdit(params); } })) })); },
        });
    }
    return columns;
};
export var referrerColumns = function () {
    var columns = [
        {
            field: "names",
            headerName: "Nombre",
            width: 400,
        },
        {
            field: "employeeCode",
            headerName: "Código usuario",
            width: 150,
        },
        {
            field: "employeePosition",
            headerName: "Posición",
            width: 250,
        },
        {
            field: "branch",
            headerName: "Sucursal",
            width: 200,
        },
        {
            field: "quoteDate",
            headerName: "Fecha de cotización",
            width: 150,
        },
        {
            field: "policyDate",
            headerName: "Fecha de emisión",
            width: 150,
        },
    ];
    return columns;
};
